module.exports = __webpack_public_path__ + "img/home-share-example.8b877b79.png";